import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customTime',
  pure: false,
  standalone: true
})
export class CustomTimePipe implements PipeTransform {

  transform(value: any, timeFormat: string = 'HH:mm'): any {
    const date = new Date(value);

    // Check if the input is a valid time
    if (isNaN(date.getTime())) {
      return value; // Return the original value if invalid
    }

    // Extract hours and minutes from the valid time
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`; // Return the formatted time
  }
}